export default {
  translation: {
    'Welcome!': 'Welcome!'
  }
};
